import React, { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { PurchasesContextProvider } from "../../Context/PurchasesContext";
import { ProductsContextProvider } from "../../Context/ProductsContext";
import { SuppliersContextProvider } from "../../Context/SuppliersContext";
import PurchaseForm from "./PurchaseForm";
import Body from "../../Common/Body";

const Purchase = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [purchase, setPurchase] = useState({});

  useEffect(() => {
    let today = new Date();
    setPurchase({
      supplierId: null,
      purchasedAt:
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate(),
      comments: "",
      purchaseAt: null,
      products: [],
    });
    setIsLoading(false);
  }, []);

  return (
    <SuppliersContextProvider>
      <PurchasesContextProvider>
        <ProductsContextProvider>
          <Body title={`Compra Nueva`} isLoading={isLoading}>
            <Box p={["0", "0.75rem"]}>
              <PurchaseForm purchase={purchase}></PurchaseForm>
            </Box>
          </Body>
        </ProductsContextProvider>
      </PurchasesContextProvider>
    </SuppliersContextProvider>
  );
};

export default Purchase;
